import {
	Box,
	Button,
	Card,
	CardContent,
	Container,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@mui/material";
import { extractUpdatedFields, isEmptyObject, pickFields } from "nhb-toolbox";
import { Controller, useForm } from "react-hook-form";
import { SERVICE_TYPES } from "src/Helpers/utils/constants";
import { toast } from "src/Toaster/Toaster";
import type { IPayableItem } from "src/Types/module/paymentableItem/itemList";
import { muiStyles } from "src/Utils/Styles";
import { useApiMutation } from "src/hooks/useApiMutation";

const useStyles = muiStyles;

interface Props {
	handleClose: () => void;
	payableItem: IPayableItem;
}

type UpdateItem = Pick<
	IPayableItem,
	"name" | "amount" | "discount" | "type" | "status"
>;

const UpdatePayableItem = ({ handleClose, payableItem }: Props) => {
	console.log(payableItem);
	const classes = useStyles();

	const { register, handleSubmit, reset, control } = useForm<UpdateItem>({
		defaultValues: {
			...pickFields(payableItem, [
				"name",
				"amount",
				"discount",
				"type",
				"status",
			]),
		},
	});

	const { mutate: updateItem, isPending } = useApiMutation<
		Partial<UpdateItem>,
		void
	>({
		method: "PATCH",
		endPoint: `/api/admin/payment-items/${payableItem.id}`,
		invalidateQueries: ["PayableItems"],
	});

	const handleUpdateItem = (formData: UpdateItem) => {
		console.log(formData, "--");
		const previousData: UpdateItem = pickFields(payableItem, [
			"name",
			"amount",
			"discount",
			"type",
			"status",
		]);

		const updatedData = extractUpdatedFields(previousData, formData);

		if (isEmptyObject(updatedData)) {
			return toast.fire({
				icon: "warning",
				title: "Nothing to update!",
				position: "top",
			});
		}

		updateItem(updatedData);
		handleClose();
		reset();
	};

	return (
		<div>
			<Container sx={{ mt: 4 }} maxWidth="lg">
				<Card>
					<CardContent>
						<Box
							component="form"
							onSubmit={handleSubmit(handleUpdateItem)}
							sx={{
								mt: 1,
							}}
						>
							<div className="form-grid">
								<TextField
									margin="normal"
									required
									fullWidth
									{...register("name")}
									label="Service Item Name"
									id="name"
									name="name"
									variant="filled"
									type="text"
									className={classes.inputText}
									InputProps={{ classes }}
								/>
							</div>

							<TextField
								margin="normal"
								required
								fullWidth
								id="amount"
								label="Service item BDT amount"
								{...register("amount", { min: 0 })}
								type="number"
								variant="filled"
								className={classes.inputText}
								InputProps={{ classes }}
							/>
							<TextField
								margin="normal"
								required
								fullWidth
								id="discount"
								label="Service item BDT discount"
								{...register("discount", { min: 0 })}
								type="number"
								variant="filled"
								className={classes.inputText}
								InputProps={{ classes }}
							/>

							<FormControl sx={{ marginTop: 2 }} fullWidth>
								<InputLabel id="type">Type</InputLabel>
								<Controller
									control={control}
									name="type"
									render={({ field }) => (
										<Select
											labelId="type"
											label="Service Type"
											{...field}
										>
											{SERVICE_TYPES?.map(
												(service, index) => (
													<MenuItem
														value={service}
														key={service + index}
													>
														{service.toUpperCase()}
													</MenuItem>
												)
											)}
										</Select>
									)}
								/>
							</FormControl>

							<FormControl sx={{ marginTop: 2 }} fullWidth>
								<InputLabel
									required
									id="status-select-label"
								>
									Status
								</InputLabel>
								<Controller
									control={control}
									name="status"
									render={({ field }) => (
										<Select
											labelId="status-select-label"
											label="Status"
											{...field}
										>
											<MenuItem value={1}>Active</MenuItem>
											<MenuItem value={0}>InActive</MenuItem>
										</Select>
									)}
								/>
							</FormControl>

							<Button
								type="submit"
								fullWidth
								variant="contained"
								disableElevation
								sx={{
									mt: 3,
									mb: 2,
									py: 1,
								}}
							>
								{isPending
									? "Updating..."
									: "Update Service Item"}
							</Button>
						</Box>
					</CardContent>
				</Card>
			</Container>
		</div>
	);
};

export default UpdatePayableItem;
